import React, { useCallback } from 'react'
import { Button } from 'reactstrap'
import { withTranslation } from 'react-i18next'

import downloadFile from '../../../helpers/downloadFile'
import { formatCSV } from '../../../helpers/csv'

const CSVButton = ({ t, filename, data, className, style = {}, disabled = false }) => {
  const handleClick = useCallback(
    () => downloadFile(filename, formatCSV(data), { type: 'text/csv' }),
    [filename, data],
  )

  return (
    <Button
      color="secondary"
      size="sm"
      className={className}
      onClick={handleClick}
      style={style}
      disabled={disabled}
    >
      {t('global.exportCsv')}
    </Button>
  )
}

export default withTranslation()(CSVButton)
